import { JSX } from 'react';
import { Translation } from 'utils/GeneratedApi';

export type ErrorType = {
  message: string;
  field: string;
  messageCode: string; // Error code
};

export enum Languages {
  en = 'en',
  no = 'no',
}

export enum COUNTRY {
  NORWAY = 'NO',
  SWEDEN = 'SE',
  DENMARK = 'DK',
  FINLAND = 'FI',
}

export type Locale = 'en' | 'no';

export const oauthProviderNameSessionKey = 'oauthProviderName';

export enum OAUTH_PROVIDERS {
  VIPPS = 'vipps',
  GITHUB = 'github',
  GOOGLE = 'google',
}

export interface APIDataResponseType {
  statusCode: number;
  success: boolean;
  messageCode: string;
  errors: ErrorType[];
  ok: boolean;
}

export enum ProductCategory {
  'digital_subscription' = 'Digital subscription',
  'physical_subscription' = 'Physical subscription',
}

export enum ActionButtonStatus {
  'draft' = 'Draft',
  'published' = 'Published',
  'unpublished' = 'Unpublished',
}
export interface CustomURLSearchParams extends URLSearchParams {
  callbackUrl?: string;
}

export type StatusType = 'draft' | 'published' | 'unpublished';

export type BillingPeriodType =
  | 'monthly'
  | 'thirty_days'
  | 'quarterly'
  | 'half_yearly'
  | 'yearly'
  | 'custom';

export type BillingPeriodUnitType = 'day' | 'week' | 'month' | 'year';

export type QueryParamsType = {
  page?: number;
  take?: number;
  isOptional?: boolean;
  status?: StatusType;
};

export type TenantDataType = {
  id: number;
  name: string;
  language: string;
  hostName: string;
  logo: string;
  favicon: string;
  siteUrl: string;
  termsUrl: string;
  privacyUrl: string;
  gtm: string;
  taxRates: number[];
};

export type SectionType =
  | 'dashboard'
  | 'members'
  | 'content'
  | 'automation'
  | 'data'
  | 'analytics'
  | 'account_settings'
  | 'segmentation'
  | 'plans_and_products';

export type SupportedLanguage = keyof Translation;

export enum PHONE_INPUT_NAME {
  COUNTRY_CALLING_CODE = 'countryCallingCode',
  PHONE_NATIONAL_NUMBER = 'phoneNationalNumber',
}

export type FlowMappingType = {
  [key: string]: {
    [key: string]: {
      [screen: number]: JSX.Element;
    };
  };
};

export enum DeviceType {
  ANDROID = 'Android',
  IOS = 'iOS',
  MAC = 'Mac',
  WINDOWS = 'Windows',
  LINUX = 'Linux',
  UNKNOWN = 'unknown',
}

export enum PaymentProviderType {
  STRIPE = 'stripe',
  VIPPS = 'vipps',
  EXTERNAL = 'external',
  NETS = 'nets',
  EfakturaAvtalegiroEhf = 'efaktura-avtalegiro-ehf',
}
